import { Component, OnInit } from '@angular/core';
import { Participant } from '../../domain/models';

@Component({
  selector: 'app-virtual-list-demo',
  template: `
    <div class="demo-container">
      <h3>Демонстрация оптимизации рендеринга</h3>
      
      <div class="controls">
        <button (click)="generateLargeList()">Сгенерировать 1000+ записей</button>
        <button (click)="clearList()">Очистить список</button>
        <input 
          type="text" 
          placeholder="Поиск..." 
          [(ngModel)]="searchQuery"
          class="search-input">
      </div>

      <div class="stats">
        <p>Всего записей: {{ participants.length }}</p>
        <p>Отфильтровано: {{ filteredParticipants.length }}</p>
        <p>Время рендеринга: {{ renderTime }}ms</p>
      </div>

      <!-- Виртуализированный список для больших данных -->
      <cdk-virtual-scroll-viewport 
        itemSize="50" 
        class="virtual-scroll-viewport" 
        *ngIf="participants.length > 500">
        <div 
          *cdkVirtualFor="let participant of filteredParticipants; trackBy: trackByParticipant"
          class="participant-item"
          [class.highlighted]="participant.isFromOtherEvent">
          <span class="bib">{{ participant.bib || 'Нет номера' }}</span>
          <span class="name">{{ participant.surname }} {{ participant.name }}</span>
          <span class="event">{{ participant.event }}</span>
          <span class="category">{{ participant.category }}</span>
        </div>
      </cdk-virtual-scroll-viewport>

      <!-- Обычный список для небольших данных -->
      <div class="regular-list" *ngIf="participants.length <= 500">
        <div 
          *ngFor="let participant of filteredParticipants; trackBy: trackByParticipant"
          class="participant-item"
          [class.highlighted]="participant.isFromOtherEvent">
          <span class="bib">{{ participant.bib || 'Нет номера' }}</span>
          <span class="name">{{ participant.surname }} {{ participant.name }}</span>
          <span class="event">{{ participant.event }}</span>
          <span class="category">{{ participant.category }}</span>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .demo-container {
      padding: 20px;
      max-width: 1200px;
      margin: 0 auto;
    }

    .controls {
      margin-bottom: 20px;
      display: flex;
      gap: 10px;
      align-items: center;
    }

    .search-input {
      padding: 8px 12px;
      border: 1px solid #ccc;
      border-radius: 4px;
      flex: 1;
      max-width: 300px;
    }

    .stats {
      background: #f5f5f5;
      padding: 10px;
      border-radius: 4px;
      margin-bottom: 20px;
    }

    .virtual-scroll-viewport {
      height: 400px;
      border: 1px solid #ddd;
      border-radius: 4px;
    }

    .regular-list {
      max-height: 400px;
      overflow-y: auto;
      border: 1px solid #ddd;
      border-radius: 4px;
    }

    .participant-item {
      display: flex;
      padding: 12px;
      border-bottom: 1px solid #eee;
      align-items: center;
      gap: 15px;
    }

    .participant-item:hover {
      background-color: #f9f9f9;
    }

    .participant-item.highlighted {
      background-color: #fff3cd;
    }

    .bib {
      font-weight: bold;
      min-width: 80px;
    }

    .name {
      flex: 1;
      font-weight: 500;
    }

    .event {
      color: #666;
      min-width: 120px;
    }

    .category {
      color: #888;
      min-width: 100px;
    }

    button {
      padding: 8px 16px;
      background: #007bff;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
    }

    button:hover {
      background: #0056b3;
    }
  `]
})
export class VirtualListDemoComponent implements OnInit {
  participants: Participant[] = [];
  filteredParticipants: Participant[] = [];
  searchQuery: string = '';
  renderTime: number = 0;

  ngOnInit() {
    this.generateLargeList();
  }

  generateLargeList() {
    const startTime = performance.now();
    
    this.participants = [];
    const names = ['Иванов', 'Петров', 'Сидоров', 'Козлов', 'Новиков'];
    const firstNames = ['Иван', 'Петр', 'Алексей', 'Дмитрий', 'Сергей'];
    const events = ['5км', '10км', '21км', '42км'];
    const categories = ['М18-24', 'М25-29', 'М30-34', 'Ж18-24', 'Ж25-29'];

    for (let i = 1; i <= 1500; i++) {
      const participant = new Participant();
      participant.id = i.toString();
      participant.bib = i.toString();
      participant.surname = names[Math.floor(Math.random() * names.length)];
      participant.name = firstNames[Math.floor(Math.random() * firstNames.length)];
      participant.event = events[Math.floor(Math.random() * events.length)];
      participant.category = categories[Math.floor(Math.random() * categories.length)];
      participant.club = `Клуб ${Math.floor(Math.random() * 20) + 1}`;
      participant.phone = `+7${Math.floor(Math.random() * 9000000000) + 1000000000}`;
      
      this.participants.push(participant);
    }

    this.filterParticipants();
    
    this.renderTime = Math.round(performance.now() - startTime);
  }

  clearList() {
    this.participants = [];
    this.filteredParticipants = [];
    this.searchQuery = '';
    this.renderTime = 0;
  }

  filterParticipants() {
    if (!this.searchQuery.trim()) {
      this.filteredParticipants = this.participants;
    } else {
      const query = this.searchQuery.toLowerCase();
      this.filteredParticipants = this.participants.filter(p => 
        p.surname.toLowerCase().includes(query) ||
        p.name.toLowerCase().includes(query) ||
        p.bib.includes(query) ||
        p.event.toLowerCase().includes(query)
      );
    }
  }

  // TrackBy функция для оптимизации
  trackByParticipant(index: number, participant: Participant): string {
    return participant.id || `${participant.surname}_${participant.name}_${index}`;
  }
}

